import React, {useContext, useEffect, useState} from "react";
import CookieConsent, {Cookies} from "react-cookie-consent";
import CookieDialog from "./CookieDialog";
import {Box, Typography, useMediaQuery} from "@mui/material";
import {PrimarySmallButton} from "../../components/buttons/mainButton";
import {LibertyTheme} from "../../tokens/libertyTheme";
import {useTranslation} from "react-i18next";
import {AppContext} from "../../App";
import ReactDOM from 'react-dom';

interface CookieElementProps {
    openCookieDialog: boolean;
    setOpenCookieDialog: (openCookieDialog: boolean) => void;
    setMatomoCookie: (matomoCookie: boolean) => void;
}

export default function CookiesElement(props: CookieElementProps): JSX.Element {
  const {openCookieDialog, setOpenCookieDialog, setMatomoCookie} = props;
  const {t} = useTranslation();
  const [store] = useContext<any>(AppContext);

  const [showCookieBanner, setShowCookieBanner] = useState<boolean>(false);

  const breakpoint = useMediaQuery('(min-width:530px)');

  function waitForElement(selector: any, callback: any): void {
    const el = document.querySelector(selector);
    if (el) return callback(el);
  
    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect();
        callback(el);
      }
    });
  
    observer.observe(document.body, {childList: true, subtree: true});
  }

  waitForElement('.btn-wrapper', (element: any) => {
    if (!element.querySelector('.react-btn-wrapper')) {
      const reactContainer = document.createElement('div');
      reactContainer.className = 'react-btn-wrapper';
      element.appendChild(reactContainer);
  
      ReactDOM.render(
        <PrimarySmallButton 
          sx={{width: "157px", fontSize: "16px"}} 
          label={t("cookie.popup_button")} 
          action={(): void => setOpenCookieDialog(true)} />,
        reactContainer
      );
    }
  });

  const handleAcceptCookie = (stripe: boolean, matomo?: boolean): void => {
    let initMatomo = false; let initStripe = false;         

    if (openCookieDialog) {
      if (stripe) {
        initStripe = true;
      }
      if (matomo) {
        initMatomo = true;
      }
    } else {
      initMatomo = true; initStripe = true;
    }

    Cookies.set("joozyCookieConsent", {"matomo": initMatomo, "stripe": initStripe}, {path: "/", expires: 365});    
    
    if (initMatomo) {
      setMatomoCookie(true);
    } else {
      Cookies.remove("_pk_cvar.6.07eb", {domain: `.${process.env.REACT_APP_COOKIE_MATOMO_DOMAIN}`, path: process.env.REACT_APP_COOKIE_PATH});
      Cookies.remove("_pk_id.6.07eb", {domain: `.${process.env.REACT_APP_COOKIE_MATOMO_DOMAIN}`, path: process.env.REACT_APP_COOKIE_PATH});
      Cookies.remove("_pk_ses.6.07eb", {domain: `.${process.env.REACT_APP_COOKIE_MATOMO_DOMAIN}`, path: process.env.REACT_APP_COOKIE_PATH});
      Cookies.remove("MATOMO_SESSID", {domain: `.${process.env.REACT_APP_COOKIE_MATOMO_DOMAIN}`, path: process.env.REACT_APP_COOKIE_PATH});
      setMatomoCookie(false);
    }

    if (!initStripe) {
      Cookies.remove("__stripe_mid", {domain: `.${window.location.hostname}`, path: process.env.REACT_APP_COOKIE_PATH});
      Cookies.remove("__stripe_sid", {domain: `.${window.location.hostname}`, path: process.env.REACT_APP_COOKIE_PATH});
    }

    setOpenCookieDialog(false);
  };

  const handleDeclineCookie = (): void => {
    Cookies.remove("_pk_cvar.6.07eb", {domain: `.${process.env.REACT_APP_COOKIE_MATOMO_DOMAIN}`, path: process.env.REACT_APP_COOKIE_PATH});
    Cookies.remove("_pk_id.6.07eb", {domain: `.${process.env.REACT_APP_COOKIE_MATOMO_DOMAIN}`, path: process.env.REACT_APP_COOKIE_PATH});
    Cookies.remove("_pk_ses.6.07eb", {domain: `.${process.env.REACT_APP_COOKIE_MATOMO_DOMAIN}`, path: process.env.REACT_APP_COOKIE_PATH});
    Cookies.remove("MATOMO_SESSID", {domain: `.${process.env.REACT_APP_COOKIE_MATOMO_DOMAIN}`, path: process.env.REACT_APP_COOKIE_PATH});
    Cookies.remove("__stripe_mid", {domain: `.${window.location.hostname}`, path: process.env.REACT_APP_COOKIE_PATH});
    Cookies.remove("__stripe_sid", {domain: `.${window.location.hostname}`, path: process.env.REACT_APP_COOKIE_PATH});
    setMatomoCookie(false);
  };

  useEffect(() => {
    let isConsent = Cookies.get('joozyCookieConsent');    
            
    if (isConsent !== undefined) {
      isConsent = JSON.parse(isConsent);
      if (!isConsent['matomo']) {        
        Cookies.remove("_pk_cvar.6.07eb", {domain: `.${process.env.REACT_APP_COOKIE_MATOMO_DOMAIN}`, path: process.env.REACT_APP_COOKIE_PATH});
        Cookies.remove("_pk_id.6.07eb", {domain: `.${process.env.REACT_APP_COOKIE_MATOMO_DOMAIN}`, path: process.env.REACT_APP_COOKIE_PATH});
        Cookies.remove("_pk_ses.6.07eb", {domain: `.${process.env.REACT_APP_COOKIE_MATOMO_DOMAIN}`, path: process.env.REACT_APP_COOKIE_PATH});
        Cookies.remove("MATOMO_SESSID", {domain: `.${process.env.REACT_APP_COOKIE_MATOMO_DOMAIN}`, path: process.env.REACT_APP_COOKIE_PATH});
      }
      if (!isConsent['stripe']) {             
        Cookies.remove("__stripe_mid", {domain: `.${window.location.hostname}`, path: process.env.REACT_APP_COOKIE_PATH});
        Cookies.remove("__stripe_sid", {domain: `.${window.location.hostname}`, path: process.env.REACT_APP_COOKIE_PATH});
      }
    } else {
      Cookies.remove("__stripe_mid", {domain: `.${window.location.hostname}`, path: process.env.REACT_APP_COOKIE_PATH});
      Cookies.remove("__stripe_sid", {domain: `.${window.location.hostname}`, path: process.env.REACT_APP_COOKIE_PATH});
      Cookies.remove("joozyFoCookie-opetest.joozy.fr", {domain: `${window.location.hostname}`, path: process.env.REACT_APP_COOKIE_PATH});
      Cookies.remove("_ga", {domain: process.env.REACT_APP_COOKIE_GA_DOMAIN, path: process.env.REACT_APP_COOKIE_PATH});
      Cookies.remove("_ga_K4BDF328X8", {domain: process.env.REACT_APP_COOKIE_GA_DOMAIN, path: process.env.REACT_APP_COOKIE_PATH});
      Cookies.remove("_ga_J9RDR2SCEZ", {domain: process.env.REACT_APP_COOKIE_GA_DOMAIN, path: process.env.REACT_APP_COOKIE_PATH});
      Cookies.remove("_gcl_au", {domain: process.env.REACT_APP_COOKIE_GTM_DOMAIN, path: process.env.REACT_APP_COOKIE_PATH});
    }
  }, [])

  useEffect(() => {
    const isConsent = Cookies.get('joozyCookieConsent');    
              
    if (isConsent !== undefined) {
      setShowCookieBanner(false);
    } else {
      setShowCookieBanner(true);
    }
  }, [Cookies.get('joozyCookieConsent')])

  return (
    <Box sx={{".btn-wrapper": {height: "70px", margin: breakpoint ? "0 0 0 20px" : "20px 0 0 0", display: "flex", flexWrap: "wrap", justifyContent: "space-between", width: "220px"}, ".react-btn-wrapper": {height: "30px", margin: "10px 0 0 0", width: "100%", "button": {backgroundColor: "ornament.main", color: "primary.main", width: "100%"}}}}>
      <CookieDialog open={openCookieDialog} close={(): void => setOpenCookieDialog(false)} handleAcceptCookie={handleAcceptCookie} />
      {showCookieBanner && <CookieConsent
        location="bottom"
        buttonText={t("cookie.button")}
        declineButtonText={t("cookie.decline_button")}
        cookieName="joozyCookieConsent"
        cookieValue={{"matomo": true, "stripe": true}}
        declineCookieValue={{"matomo": false, "stripe": false}}
        onAccept={(): void => handleAcceptCookie(true, true)}
        onDecline={handleDeclineCookie}
        enableDeclineButton
        expires={180}
        buttonWrapperClasses={"btn-wrapper"}
        style={{
          backgroundColor: LibertyTheme(store.theme.palette.primary.main, store.theme.palette.primary.contrastText).palette.primary.main,
          padding: `${LibertyTheme(store.theme.palette.primary.main, store.theme.palette.primary.contrastText).spacing(3)} ${LibertyTheme(store.theme.palette.primary.main, store.theme.palette.primary.contrastText).spacing(3)}`,
          boxSizing: "border-box",
          height: "fit-content",
          alignItems: "center",
          flexWrap: "unset",
          flexDirection: breakpoint ? "row" : "column"
        }}
        contentStyle={{
          margin: 0,
          flex: 1
        }}
        buttonStyle={{
          color: LibertyTheme(store.theme.palette.primary.main, store.theme.palette.primary.contrastText).palette.neutral.dark,
          backgroundColor: LibertyTheme(store.theme.palette.primary.main, store.theme.palette.primary.contrastText).palette.ornament.light,
          borderRadius: 4,
          margin: 0,
          fontFamily: LibertyTheme(store.theme.palette.primary.main, store.theme.palette.primary.contrastText).typography.fontFamily,
          fontWeight: 700,
          height: "30px",
          fontSize: "16px",
          width: "42%",
          minWidth: "100px"
        }}
        declineButtonStyle={{
          color: LibertyTheme(store.theme.palette.primary.main, store.theme.palette.primary.contrastText).palette.neutral.dark,
          backgroundColor: LibertyTheme(store.theme.palette.primary.main, store.theme.palette.primary.contrastText).palette.ornament.light,
          borderRadius: 4,
          margin: "0 12px 0 0",
          fontFamily: LibertyTheme(store.theme.palette.primary.main, store.theme.palette.primary.contrastText).typography.fontFamily,
          fontWeight: 700,
          height: "30px",
          fontSize: "16px",
          width: "42%",
          minWidth: "100px"
        }}
      >
        <Box sx={{display: "flex", height: "fit-content", alignItems: "center"}}>
          <Typography variant="body2" color="ornament.light" sx={{fontSize: "18px"}}>{t("cookie.content")}</Typography>
        </Box>
      </CookieConsent>}
    </Box>
  )
}
